import React, {useEffect, useState} from "react";

import axios from "../../utils/apiClient";
import {Button} from "../../components/buttons";
import {Col, Row} from "react-bootstrap";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import Select from 'react-select'
import {format} from "date-fns";
import {EQHDatePicker} from "../../components/datePicker";
import {getErrorCode, TRACK_EVENTS, trackPendoEvent} from "../../utils/pendoTrack";

const baseURLSR =
  process.env.REACT_APP_REST_API_BASE_URL + "/v1/submit-recent-visit";

const componentName = "SubmitRecentVisit";

const SubmitRecentVisitBody = ({
  patient,
  updateParent,
  closeSubmitModal
}) => {
  const [selectedDate, setSelectedDate] = useState(patient.recentVisit);
  const [selectedStatus, setSelectedStatus] = useState(patient.recentVisitStatus ? patient.recentVisitStatus.name : null);
  const [maxDate, setMaxDate] = useState(null);

  const isFormValid = () => {
    return (selectedStatus && selectedDate);
  };

  const submitRecentVisit = () => {
    const query = {
      patientId: patient.id,
      recentVisit: selectedDate,
      recentVisitStatus: selectedStatus
    };
    axios
      .post(baseURLSR + "/save", query, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (response) => {
        trackPendoEvent(TRACK_EVENTS.QUICKLIST_RECENT_VISIT_SUBMIT, {
          route: window?.location?.pathname,
          source_module: "SubmitRecentVisit.submitRecentVisit",
          quicklist_type: "recent_visit",
          success: true
        });
        await updateParent(response.data, "SubmitRecentVisit");
        closeSubmitModal();
      })
      .catch((error) => {
        trackPendoEvent(TRACK_EVENTS.QUICKLIST_RECENT_VISIT_SUBMIT, {
          route: window?.location?.pathname,
          source_module: "SubmitRecentVisit.submitRecentVisit",
          quicklist_type: "recent_visit",
          success: false,
          error_code: getErrorCode(error, "quicklist_recent_visit_failed")
        });
      });
  };

  const statusOptions = [
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'SCHEDULED', label: 'Scheduled' }
  ]

  useEffect(() => {
    if(selectedStatus === "COMPLETED") {
      setMaxDate(format(new Date(), "yyyy-MM-dd"))
      if(selectedDate > format(new Date(), "yyyy-MM-dd")) {
        setSelectedDate(null);
      }
    } else {
      setMaxDate(null)
    }
  }, [selectedDate, selectedStatus])

  return (
    <>
      <div style={{minHeight: "150px"}}>
          <Row className="mb-3">
              <Col sm={6}>
                <label id={`${componentName}-recentVisitStatusLabel`} className="d-block">
                  Visit Status<span className="text-danger">*</span>
                </label>
                <Select
                    id={`${componentName}-recentVisitStatusValue`}
                    options={statusOptions}
                    onChange={(e) => setSelectedStatus(e.value)}
                />
              </Col>
              <Col sm={3}>
                <label id={`${componentName}-recentVisitDateLabel`} className="d-block">Visit Date<span className="text-danger">*</span>
                </label>
                <div className="w-100">
                  <EQHDatePicker
                      id={`${componentName}-recentVisitDateValue`}
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.strDate)}
                      max={maxDate}
                  />
                </div>
              </Col>
          </Row>
        <div className="text-end">
          <Button id={`${componentName}-closeButton`} onClick={() => closeSubmitModal()} className="me-3">Close</Button>
          <Button id={`${componentName}-submitButton`} disabled={!isFormValid()} onClick={() => submitRecentVisit()}>Submit</Button>
        </div>
      </div>
    </>
  );
};

export default SubmitRecentVisitBody;
